var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoBankWestpac(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80 0c-1.172.46-1.95 3.36-1.95 3.36l-7.216 24.033C70 30.41 67.4 32 64.45 32H48.607c1.135-.2 2.38-3.39 2.38-3.39l8.05-23.925C60.175 1.035 62.11 0 65.055 0H80zM0 0c1.172.46 1.95 3.36 1.95 3.36l7.216 24.033C10 30.41 12.6 32 15.55 32h15.842c-1.135-.2-2.38-3.39-2.38-3.39L20.96 4.685C19.825 1.035 17.89 0 14.945 0H0z",
    fill: "#E41B13"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.392 0h17.216v32H31.392V0z",
    fill: "#E41B13"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBankWestpac);
export default __webpack_public_path__ + "static/media/logo-bank-westpac.5fe1fc3a14405bc96e10c2b0759b8b9e.svg";
export { ForwardRef as ReactComponent };